module.exports = __webpack_public_path__ + "src/assets/img/cd01.103183d5.png";